import { cn } from '@/lib/cn';

/**
 * A labelled `<select>`, the way ExpensesPage draws one, plus the phone
 * rules Input already has: 44px and 16px text under a finger, so iOS
 * neither misses the tap nor zooms the page.
 */
export function SelectField({
  id,
  label,
  required,
  value,
  onChange,
  error,
  children,
}: {
  id: string;
  label: string;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="flex items-center text-sm font-medium">
        <label htmlFor={id}>{label}</label>
        {required ? (
          <span aria-hidden="true" className="ml-0.5 text-destructive">
            *
          </span>
        ) : null}
      </span>
      <select
        id={id}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={error ? true : undefined}
        className={cn(
          'min-h-9 w-full rounded-md border bg-background px-3 text-sm shadow-sm touch:min-h-11 touch:text-base',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          error ? 'border-destructive' : 'border-input',
        )}
      >
        {children}
      </select>
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
